module.exports = __webpack_public_path__ + "img/hohlschnitt_orange_ral2008.f5f638d3.jpg";